import { isValiError, parse, summarize } from 'valibot';
import type { Seo } from '../model/schemas';

export function parseSeoOrThrow(schema: Parameters<typeof parse>[0], input: unknown): Seo {
  try {
    return parse(schema, input) as Seo;
  } catch (error) {
    const details = createSeoValidationErrorDetails(error);

    throw createError({
      statusCode: 503,
      message: details.message,
      data: details,
    });
  }
}

function createSeoValidationErrorDetails(error: unknown) {
  if (!isValiError(error)) {
    return {
      message: 'Invalid SEO data',
      error,
    };
  }

  const issues = error.issues.map((issue) => ({
    field: getIssuePath(issue),
    message: issue.message,
    type: issue.type,
    expected: issue.expected,
    received: issue.received,
    input: formatIssueInput(issue.input),
  }));
  const issueMessages = issues.map((issue) => `${issue.field}: ${issue.message}`);

  return {
    message: `Invalid SEO data: ${issueMessages.join('; ')}`,
    name: error.name,
    summary: summarize(error.issues),
    issues,
  };
}

function getIssuePath(issue: { path?: { key?: unknown }[] }): string {
  const path = issue.path
    ?.map((item) => String(item.key ?? ''))
    .filter((key) => key.length > 0)
    .join('.');

  return path || 'root';
}

function formatIssueInput(input: unknown): unknown {
  if (typeof input !== 'string') return input;
  if (input.length <= 200) return input;

  return `${input.slice(0, 200)}...`;
}
